<template>
  <v-chart :options="options" class="width-100" :autoresize="true"/>
</template>

<script>
import moment from 'moment'
import ECharts from 'vue-echarts'
import { secToMin } from '@/utils/formatUtils'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/dataZoom'

export default {
  name: 'LineChart',
  components: {
    'v-chart': ECharts
  },
  props: {
    title: { type: String, default: '' },
    chart: { type: Object, required: true },
    legend: { type: Array, default: () => [] }
  },
  computed: {
    options() {
      return {
        title: {
          text: this.title,
        },
        tooltip: {
          trigger: 'axis',
          //moment.duration(
          formatter: params => `<div>${params.reduce((string, item) => string + `<br/><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${item.color};"></span><b>${item.seriesName}:</b> ${secToMin(item.data)}`, `<b>${params[0].axisValueLabel}</b>`)}</div>`,
          axisPointer: {
              type: 'shadow',
          }
        },
        dataZoom: [{
            type: 'inside'
        }, {
            type: 'slider'
        }],
        legend: {
          data: this.legend || this.chart.legend //['2011年', '2012年']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: 50,
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
              formatter: value => secToMin(value)
          },
          boundaryGap: [0, 0.01]
        },
        xAxis: {
          type: 'category',
          data: this.chart.labels
        },
        series: this.chart.series
      }
    }
  }
}
</script>